export const Texts = {
    LOADING_CONTENT_DESCRIPTION: 'Cargando...'
}
